"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Telegraph Public API
 * Public API offering access to Telegraph data
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: bookingsupport@telegraph.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBookingRequestStatusItemToJSON = exports.GetBookingRequestStatusItemFromJSONTyped = exports.GetBookingRequestStatusItemFromJSON = exports.instanceOfGetBookingRequestStatusItem = void 0;
var OriginalRequest_1 = require("./OriginalRequest");
var TenderAcknowledgement_1 = require("./TenderAcknowledgement");
var TenderAdvice_1 = require("./TenderAdvice");
var TenderRequest_1 = require("./TenderRequest");
/**
 * Check if a given object implements the GetBookingRequestStatusItem interface.
 */
function instanceOfGetBookingRequestStatusItem(value) {
    return true;
}
exports.instanceOfGetBookingRequestStatusItem = instanceOfGetBookingRequestStatusItem;
function GetBookingRequestStatusItemFromJSON(json) {
    return GetBookingRequestStatusItemFromJSONTyped(json, false);
}
exports.GetBookingRequestStatusItemFromJSON = GetBookingRequestStatusItemFromJSON;
function GetBookingRequestStatusItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'controlNumber': json['controlNumber'] == null ? undefined : json['controlNumber'],
        'shipmentNumber': json['shipmentNumber'] == null ? undefined : json['shipmentNumber'],
        'bolNumber': json['bolNumber'] == null ? undefined : json['bolNumber'],
        'equipmentId': json['equipmentId'] == null ? undefined : json['equipmentId'],
        'patternId': json['patternId'] == null ? undefined : json['patternId'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'destination': json['destination'] == null ? undefined : json['destination'],
        'state': json['state'] == null ? undefined : json['state'],
        'submittedDate': json['submittedDate'] == null ? undefined : (new Date(json['submittedDate'])),
        'requestId': json['requestId'] == null ? undefined : json['requestId'],
        'patternVersion': json['patternVersion'] == null ? undefined : json['patternVersion'],
        'acknowledgement': json['acknowledgement'] == null ? undefined : (0, TenderAcknowledgement_1.TenderAcknowledgementFromJSON)(json['acknowledgement']),
        'advice': json['advice'] == null ? undefined : (0, TenderAdvice_1.TenderAdviceFromJSON)(json['advice']),
        'tenderRequest': json['tenderRequest'] == null ? undefined : (0, TenderRequest_1.TenderRequestFromJSON)(json['tenderRequest']),
        'originalRequest': json['originalRequest'] == null ? undefined : (0, OriginalRequest_1.OriginalRequestFromJSON)(json['originalRequest']),
        'carrier': json['carrier'] == null ? undefined : json['carrier'],
    };
}
exports.GetBookingRequestStatusItemFromJSONTyped = GetBookingRequestStatusItemFromJSONTyped;
function GetBookingRequestStatusItemToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'controlNumber': value['controlNumber'],
        'shipmentNumber': value['shipmentNumber'],
        'bolNumber': value['bolNumber'],
        'equipmentId': value['equipmentId'],
        'patternId': value['patternId'],
        'origin': value['origin'],
        'destination': value['destination'],
        'state': value['state'],
        'submittedDate': value['submittedDate'] == null ? undefined : ((value['submittedDate']).toISOString()),
        'requestId': value['requestId'],
        'patternVersion': value['patternVersion'],
        'acknowledgement': (0, TenderAcknowledgement_1.TenderAcknowledgementToJSON)(value['acknowledgement']),
        'advice': (0, TenderAdvice_1.TenderAdviceToJSON)(value['advice']),
        'tenderRequest': (0, TenderRequest_1.TenderRequestToJSON)(value['tenderRequest']),
        'originalRequest': (0, OriginalRequest_1.OriginalRequestToJSON)(value['originalRequest']),
        'carrier': value['carrier'],
    };
}
exports.GetBookingRequestStatusItemToJSON = GetBookingRequestStatusItemToJSON;
